import { motion } from "framer-motion";

export const Footer = () => (
  <footer className="relative border-t border-border overflow-hidden bg-black" data-testid="site-footer">
    <div
      className="absolute inset-0 pointer-events-none opacity-60"
      style={{
        background:
          "radial-gradient(circle at 12% 18%, rgba(37, 99, 235, 0.12), transparent 32%), radial-gradient(circle at 78% 72%, rgba(163, 230, 53, 0.06), transparent 28%)",
      }}
    />
    <div className="relative px-6 md:px-12 max-w-[1400px] mx-auto py-20 md:py-28">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      >
        <div className="font-display font-semibold tracking-tighter leading-none text-[22vw] md:text-[14rem] text-stroke select-none" aria-hidden="true">
          YKD
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mt-4 md:-mt-6">
          <div className="md:col-span-5">
            <div className="font-mono text-xs tracking-[0.25em] uppercase text-accent mb-4">
              Parent Company
            </div>
            <p className="text-base leading-relaxed text-muted-foreground max-w-sm">
              YIIS-100 is developed and maintained by YKD ENTERPRISES — a product
              house building precision software for investors and operators.
            </p>
          </div>
          <div className="md:col-span-4">
            <div className="font-mono text-xs tracking-[0.25em] uppercase text-muted-foreground mb-4">
              Product Line
            </div>
            <ul className="flex flex-col gap-2 font-mono text-xs tracking-[0.15em] uppercase">
              <li className="flex items-center gap-3">
                <span className="w-1.5 h-1.5 bg-accent" /> YIIS-100 v1.0 — Website ready
              </li>
              <li className="flex items-center gap-3 text-muted-foreground">
                <span className="w-1.5 h-1.5 bg-border" /> Future products — In development
              </li>
              <li className="flex items-center gap-3 text-muted-foreground">
                <span className="w-1.5 h-1.5 bg-border" /> New YIIS features — Rolling out
              </li>
            </ul>
          </div>
          <div className="md:col-span-3 flex md:justify-end items-end">
            <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground">
              © {new Date().getFullYear()} YKD ENTERPRISES
              <br />
              ALL RIGHTS RESERVED
              <br />
              <a href="/help" data-testid="footer-help-link" className="hover:text-accent transition-colors duration-300">
                USER GUIDE
              </a>
              <br />              <a href="/ipo-portfolio-tracker" data-testid="footer-ipo-tracker-link" className="hover:text-accent transition-colors duration-300">
                IPO TRACKING GUIDE
              </a>
              <br />
              <a href="/admin" data-testid="footer-admin-link" className="hover:text-accent transition-colors duration-300">
                ADMIN LOGIN
              </a>
              <br />
              <a href="/privacy" data-testid="footer-privacy-link" className="hover:text-accent transition-colors duration-300">
                PRIVACY
              </a>
              <span aria-hidden="true"> · </span>
              <a href="/terms" data-testid="footer-terms-link" className="hover:text-accent transition-colors duration-300">
                TERMS
              </a>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  </footer>
);
